import "./LogoItem.css";
import React from "react";
import PropTypes from "prop-types";
import HeaderItem from "../../mixins/HeaderItem";

class LogoItem extends React.Component {
    static propTypes = {
        url: PropTypes.string.isRequired
    };

    render() {
        return (
            <a className= "site-logo-container" aria-label="Gradifi" href={this.props.url} onClick={this.handleClick}>
                <div className="site-logo" />
            </a>
        );
    }
}

export default HeaderItem(LogoItem, "logo-item");
